module.exports = __webpack_public_path__ + "img/dz.ef401afe.png";